import { useState, useEffect } from 'react'

// Initial time: 23 hours, 58 minutes, 40 seconds in seconds
const INITIAL_SECONDS = 23 * 3600 + 58 * 60 + 40

export function useCountdown() {
  const [timeLeft, setTimeLeft] = useState(INITIAL_SECONDS)

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0))
    }, 1000)

    return () => clearInterval(timer)
  }, [])

  const hours = Math.floor(timeLeft / 3600)
  const minutes = Math.floor((timeLeft % 3600) / 60)
  const seconds = timeLeft % 60

  return {
    hours: hours.toString().padStart(2, '0'),
    minutes: minutes.toString().padStart(2, '0'),
    seconds: seconds.toString().padStart(2, '0'),
    isZero: timeLeft === 0,
  }
}
